import {Controller} from "stimulus";
import getFilters from "util/filter_params";

export default class extends Controller {
  static targets = ['adults', 'children']

  maximum = 1
  currentAdults = 0
  currentChildren = 0
  currentTotal = 0
  preloaded = false

  connect() {
    this.maximum = Number(this.data.get('max'));

    const filters = getFilters({
      adults: this.adultsTarget.value,
      children: this.childrenTarget.value
    }, true);

    this.adultsTarget.value = filters.get('adults') || 2;
    this.childrenTarget.value = filters.get('children') || 0;

    // Wrap update in debounce
    this.debouncedUpdate = this.debounce(this.update.bind(this), 300);

    if (this.data.has('is-initial-max')) {
      this.update();
    }
  }

  update() {
    

    this.updateCurrent();

    // Enforce minimums
    if (this.currentAdults < 2) {
      this.currentAdults = 2;
      this.adultsTarget.value = 2;
    }

    if (this.currentChildren < 0) {
      this.currentChildren = 0;
      this.childrenTarget.value = 0;
    }

    // Enforce total maximum
    this.currentTotal = this.currentAdults + this.currentChildren;
    if (this.currentTotal > this.maximum) {
      const overflow = this.currentTotal - this.maximum;

      // Reduce children first
      if (this.currentChildren >= overflow) {
        this.currentChildren -= overflow;
        this.childrenTarget.value = this.currentChildren;
        this.childrenTarget.dispatchEvent(new Event('input', { bubbles: true }));
      } else {
        // Then reduce adults but not below 2
        const remainingOverflow = overflow - this.currentChildren;
        this.currentChildren = 0;
        this.childrenTarget.value = 0;

        this.currentAdults = Math.max(2, this.currentAdults - remainingOverflow);
        this.adultsTarget.value = this.currentAdults;
        this.adultsTarget.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }

    // Update input max attributes, never negative
    const maxAdults = Math.max(2, this.maximum - this.currentChildren);
    const maxChildren = Math.max(0, this.maximum - this.currentAdults);

    this.adultsTarget.setAttribute('max', maxAdults);
    this.childrenTarget.setAttribute('max', maxChildren);


    this.updateCurrent();
  }

  updateCurrent() {
    const filters = getFilters({
      adults: this.adultsTarget.value,
      children: this.childrenTarget.value
    });
    this.currentAdults = Number(filters.get('adults') || 2);
    this.currentChildren = Number(filters.get('children') || 0)
    this.currentTotal =  this.currentAdults + this.currentChildren;
  }


  debounce(fn, delay = 300) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), delay);
    };
  }

}
